import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Tooltip } from "shared/ui/tooltip/Tooltip"

import { useAppSidebarAnimationState } from "../lib/useAppSidebarAnimationState"
import { AppSidebarViewModel } from "../model/useAppSidebarViewModel"
import { AppSidebarContent } from "./AppSidebarContent"

export const AppSidebarDesktop = React.memo(
  (viewModel: AppSidebarViewModel) => {
    const { isExpanded = false } = viewModel
    const { t } = useTranslation()

    const {
      elementRef,
      animationState,
      classNames: animationClassNames
    } = useAppSidebarAnimationState({
      isExpanded
    })

    return (
      <aside
        ref={elementRef}
        className={classNames("app-sidebar", "app-sidebar-desktop", {
          "app-sidebar-desktop--expand": animationClassNames.isExpand,
          "app-sidebar-desktop--expand-done": animationClassNames.isExpandDone,
          "app-sidebar-desktop--collapse": animationClassNames.isCollapse,
          "app-sidebar-desktop--collapse-done":
            animationClassNames.isCollapseDone,
          "app-sidebar-desktop--instant": animationClassNames.isInstant
        })}
        data-testid="app-sidebar"
        data-sidebar-variant="desktop"
        data-animation-state={animationState}
        aria-label={t("Menu.Menu")}
      >
        <Tooltip.Provider disabled={isExpanded}>
          <AppSidebarContent {...viewModel} />
        </Tooltip.Provider>
      </aside>
    )
  }
)

AppSidebarDesktop.displayName = "AppSidebarDesktop"
